import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import { updateCurrentBridgeList } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"
import Btn from "../../shared/button/Btn"
import formatConverter from "../../../helper/formatConverter"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1200px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 1000px;
            height: auto;
            display: flex;
            justify-content: center;
            padding: 20px;
            gap: 40px;

            .side{
                width: calc(50% - 20px);
                display: flex;
                flex-direction: column;
                min-height: 300px;


                .title{
                    width: 100%;
                    padding: 12px;
                    border-radius: 5px;
                    background-color: ${({ theme }) => theme.secondaryBgColor};
                    margin-bottom: 10px;
                }

                .list{
                    display: flex;
                    flex-direction: column;
                    gap: 10px;


                    .item{
                        padding: 10px;
                        border: 1px solid ${({ theme }) => theme.mainBorderColor};
                        border-radius: 5px;
                        cursor: pointer;
                        font-weight: var(--font-weight-md);

                        &:hover{
                            background-color: ${({ theme }) => theme.secondaryBgColor};
                        }
                    }

                    .active{
                        background-color: var(--color-main) !important;
                        color: ${({theme}) => theme.reverseMainTextColor} !important;
                        border-color: transparent ;
                    }
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const aracTypes = [
    {
        type: 4,
        trucks: "Tır, Kırkayak"
    },
    {
        type: 3,
        trucks: "10 Teker Kamyon"
    },
    {
        type: 2,
        trucks: "6 Teker Kamyon, Kamyonet, Panelvan"
    },
    {
        type: 5,
        trucks: "Kamyon Römork"
    },
]

const AddBridgePricesModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const [message, setMessage] = useState("")
    const [isSubmited, setIsSubmitted] = useState(false)

    const { lockScroll, unlockScroll } = useScrollLock();
    const {modalLocation } = useSelector(state => state.modal)

    const {kopruUcretList} = useSelector(state => state.calc)

    const {
        truckType
    } = useSelector(state => state.nakliyeHesaplama)

    const [selectedKopru, setSelectedKopru] = useState(null)
    const [selectedAracType, setSelectedAracType] = useState(null)

    //! bu apiden gelen datanın unique olarak filterlenmiş hali 
    const [kopruList, setkopruList] = useState([])

    //! bu seçilen köprüye göre apiden gelen datanın filterlenmiş hali 
    const [aracTipiList, setAracTipiList] = useState([])


    useEffect(() => {
        if(truckType.id){

            
            const aracType = aracTypes.find((item) => {
                return item.trucks.includes(truckType.text)
            })
            

            const bridgeItem = aracTipiList.find(item => {
                return item.aracSınıfı === aracType.type
            })
            
            setSelectedAracType(bridgeItem || null)
        }
        
    },[selectedKopru, truckType.id, aracTipiList])

    

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    

    useEffect(() => {
        if(kopruUcretList){
            const list = kopruUcretList.map(item => item.kopruIsmi)
            setkopruList([...new Set(list)])
         }
    },[kopruUcretList])

    useEffect(() => {
        if(selectedKopru) {
            const list = kopruUcretList.filter((item) => {
                return item.kopruIsmi === selectedKopru
            }).sort((a,b) => a.aracSınıfı - b.aracSınıfı)

            setAracTipiList(list)
        }
    },[selectedKopru])


    useEffect(() => {
        if(isSubmited){
            if(selectedKopru && selectedAracType){
                setMessage("")
            }
            else{
                setMessage("Lütfen köprü ve araç tipini seçiniz.")
            }
        }
    },[isSubmited, selectedKopru, selectedAracType])

    const handleSubmit = () => {
        setIsSubmitted(true)
        if(!selectedKopru || !selectedAracType){
            setMessage("Lütfen köprü ve araç tipini seçiniz.")
        }
        else{
            //! bu selectedAracType aslında bir object olduğu için direk bunu verebiliriz.
            dispatch(updateCurrentBridgeList(selectedAracType))
            dispatch(showModal(null))
        }
    }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Köprü Ekle"}/>
        <div className="content">
            <div className="side">
                <h4 className="title">Köprü Seçiniz</h4>
                <div className="list">
                    {
                        kopruList.map((item) =>(
                            <div onClick={() => {setSelectedKopru(item); setSelectedAracType(null)}} className={selectedKopru === item ? "active item": "item" }>
                                {item === "Osmangazi" && "Osmangazi Köprüsü"}
                                {item === "Yavuzsultan" && "Yavuz Sultan Selim Köprüsü"}
                                {item === "1915" && "1915 Çanakkale Köprüsü"}
                                {item === "Fatih" && "Fatih Sultan Mehmet Köprüsü"}
                                {item === "15Temmuz" && "15 Temmuz Şehitler Köprüsü"}
                                </div>
                        ))
                    }
                </div>
            </div>
            {
                selectedKopru &&
                <div className="side">
                    <h4 className="title">Araç Tipi Seçiniz</h4>

                    <div className="list">
                        {
                            aracTipiList.map((item) =>(
                                <div onClick={() => setSelectedAracType(item)} className={selectedAracType?.id === item.id ? "active item": "item" }>({item.aracSınıfı}) {aracTypes.find(itemm => itemm.type === item.aracSınıfı).trucks} ({formatConverter(item.ucret, 0)} TL)</div>
                            ))
                        }
                    </div>

                </div>
            }
        </div>
        {
            message &&
            <div>{message}</div>
        }
        <div className='button-grp'>
            <Btn bgColor="var(--color-main)" color="#fff" width={"200px"} handleClick={handleSubmit}>Ekle</Btn>
            <Btn bgColor="transparent" color="var(--color-main)" borderColor="var(--color-main)" width={"200px"} handleClick={()=> dispatch(showModal(null))}>Vazgeç</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddBridgePricesModal